/* WP: Verdichtungsreduzierung – separates Hover-Menü am Desktop. */
(() => {
  const target = '/collections/verdichtungsreduzierung';
  const init = () => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)').matches) return;
    document.querySelectorAll('.header__inline-menu header-menu').forEach(menu => {
      const link = menu.querySelector('summary a[data-wp-vdr-link]');
      const details = menu.querySelector(':scope > details');
      if (!link || !details || menu.dataset.wpVdHoverBound) return;
      menu.dataset.wpVdHoverBound = 'true';
      const summary = details.querySelector(':scope > summary');
      let ready = false;
      let exitTimer;
      const close = () => {
        details.open = false;
        summary?.setAttribute('aria-expanded', 'false');
      };
      // Prevent nested link click from toggling the <summary>.
      link.addEventListener('click', (event) => {
        event.stopPropagation();
        try { sessionStorage.setItem('wpVdSuppressHover', '1'); } catch(e) {}
        close();
      });
      // Hover will only open after the pointer has newly entered.
      menu.addEventListener('pointerenter', () => {
        clearTimeout(exitTimer);
        if (!ready) return;
        details.open = true;
        summary?.setAttribute('aria-expanded', 'true');
      });
      menu.addEventListener('pointerleave', () => {
        exitTimer = setTimeout(close, 100);
        ready = true;
        try { sessionStorage.removeItem('wpVdSuppressHover'); } catch(e) {}
      });
      // If the pointer is already over the menu after page navigation,
      // require an exit before it may open again.
      let suppressed = false;
      try { suppressed = sessionStorage.getItem('wpVdSuppressHover') === '1'; } catch(e) {}
      ready = !suppressed;
      if (suppressed) close();
      menu.addEventListener('focusout', (event) => {
        if (!menu.contains(event.relatedTarget)) close();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();